import React, { PropTypes } from 'react'
import ReactDOM from 'react-dom';


export default class TooltipSearchForm extends React.Component {

  static propTypes = {
    onSearch: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  componentDidUpdate(){
    ReactDOM.findDOMNode(this.refs.search_input).focus();
  }

  scheduleClose() {
    this._timeout = setTimeout(() => {
      this.props.onCancel();
    }, 1000);
  }

  cancelClose() {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }

  render() {
    return (
      <div className="categoryDetail-helpTooltip" onMouseEnter={this.cancelClose.bind(this)} onMouseLeave={this.scheduleClose.bind(this)}>
        <div className="categoryDetail-cancelHelpTooltip">
          <a onClick={this.props.onCancel}><i className="search-box-close fa fa-close"></i></a>
        </div>
        <b>Don't see your city, or country...<br/>
        type it in the searchbox</b>
        <form onSubmit={(e)=> this.props.onSearch(this.refs.search_input.value, e)} action="/search" method="get" className="tooltip-search-form">
          <input placeholder="Search..." type="text" ref="search_input" name="q"/>
          <button className="button" type="submit">Go</button>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TooltipSearchForm.jsx